import { Dispatch } from 'react';
import track from 'c9-tracking';
import { GiftCardKeys, IAction, States, WhitelabelPartner } from '../interfaces/interfaces';
import { IConfigProps } from '../context/ConfigContext';
import { genericRequest } from '../store/Actions';
import { SET_DATA_MODEL_VALUE, SET_LABELS } from '../store/ActionKeys';

export const getGiftcard = async ({
    giftcardEndpoint,
    product,
    partner,
    dispatch
}: {
    giftcardEndpoint: IConfigProps['endpoint']['giftcard'];
    product: IConfigProps['product'];
    partner: States['selection']['partner'];
    dispatch: Dispatch<IAction>;
}) => {
    try {
        let giftCardKeys = GiftCardKeys[product];
        if (partner === WhitelabelPartner.TEDDY_BEAR) giftCardKeys = GiftCardKeys.CHID_TB;

        const response = await genericRequest({
            ...giftcardEndpoint,
            url: `${giftcardEndpoint.url}?key=${giftCardKeys}`
        });

        dispatch({
            type: SET_DATA_MODEL_VALUE,
            payload: {
                productKey: product,
                dataKey: 'giftcard',
                value: response
            }
        });
        track.info([{ key: 'gift card status: ', value: response?.status }]);

        const isGiftcardActive = response.status === 'active';

        // get labels if giftcard is active
        if (isGiftcardActive) {
            const labelResponse = await genericRequest({
                method: 'GET',
                url: 'https://www.topdanmark.dk/rest/resourcebundle/giftcard/',
                headers: {}
            });

            dispatch({
                type: SET_LABELS,
                payload: {
                    productKey: product,
                    labelKey: 'giftcard',
                    value: labelResponse
                }
            });
        }
    } catch (error) {
        console.log(error);
        // ignore error...
    }
};
